import {CustomerFormAddress} from "../../types/forms"

export const composeFullName = (
    {firstName, lastName}: Pick<CustomerFormAddress, 'firstName' | 'lastName'>
): string => {
    return firstName + ' ' + lastName
}
